<div class="bg-light">
    <div class="container py-5">
        <main>
        <div class="py-5 text-center">
            <!-- <img class="d-block mx-auto mb-4" src="../assets/brand/bootstrap-logo.svg" alt="" width="72" height="57"> -->
            <h2>Checkout</h2>
            <p class="lead">
                Complete your purchase by filling out the billing and payment information below.
                We use secure 256-bit SSL encryption to ensure your data stays safe.
                Once the payment is confirmed, you’ll receive a confirmation email with your receipt and access details.
            </p>
        </div>

        <div class="row g-5">
            <div class="col-md-5 col-lg-4 order-md-last">
                <h4 class="d-flex justify-content-between align-items-center mb-3">
                <span class="text-primary">Your cart</span>
                <span class="badge bg-primary rounded-pill">1</span>
                </h4>
                <ul class="list-group mb-3">
                <li class="list-group-item d-flex justify-content-between lh-sm">
                    <div>
                    <h6 class="my-0">{{ planDetails?.name }}</h6>
                    <small class="text-muted">{{ planDetails?.description }}</small>
                    <small class="text-muted">{{ planDetails?.boats }}</small>
                    </div>
                    <span class="text-muted">
                      {{ cartTotal | currency:cartCurrency }}
                      <small class="d-block text-muted">{{ planDetails?.billingPeriod === 'one-time' ? 'one-time' : (planDetails?.billingPeriod === 'monthly' ? 'per month' : 'per year') }}</small>
                    </span>
                </li>
                <li class="list-group-item d-flex justify-content-between bg-light" *ngIf="appliedPromo">
                    <div [ngClass]="getAppliedPromoStripeSyncError() ? 'text-danger' : 'text-success'">
                    <h6 class="my-0">Promo code</h6>
                    <small>{{ appliedPromo?.id || appliedPromo?.code }}</small>
                    </div>
                    <span [ngClass]="getAppliedPromoStripeSyncError() ? 'text-danger' : 'text-success'">
                      −{{ discount | currency:cartCurrency }}
                    </span>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-center checkout-due-now">
                    <span class="checkout-due-now-label">
                      {{ checkoutForm.get('paymentMethod')?.value === 'stripe' ? 'You pay today' : 'Total' }}
                      ({{ checkoutForm.get('paymentMethod')?.value === 'stripe' ? stripePreviewCurrency : cartCurrency }})
                    </span>
                    <strong class="checkout-due-now-amount">
                      {{ displayTotalAmount | currency:(checkoutForm.get('paymentMethod')?.value === 'stripe' ? stripePreviewCurrency : cartCurrency) }}
                    </strong>
                </li>
                </ul>
                <div class="alert alert-secondary mb-3" *ngIf="checkoutForm.get('paymentMethod')?.value === 'stripe'">
                  <div *ngIf="stripePreviewLoading">Calculating your payment estimate...</div>
                  <ng-container *ngIf="!stripePreviewLoading">
                    <div *ngIf="stripePreview" class="small">
                      <div *ngIf="isUpgrade && stripePreview.currency_mismatch" class="mb-2">
                        <strong>Different currency than your current subscription</strong>
                        <div class="text-muted">
                          Your current subscription is billed in
                          <strong>{{ stripePreview.current_subscription_currency }}</strong>
                          but the selected plan is billed in
                          <strong>{{ stripePreview.currency }}</strong>.
                          Payment providers cannot prorate across currencies, so a brand new
                          subscription will be created and your previous one cancelled
                          automatically. You will be charged the full plan price now.
                        </div>
                      </div>
                      <div *ngIf="isUpgrade && !stripePreview.currency_mismatch && stripePreview.proration_amount > 0" class="mb-2">
                        <strong>Why is the amount lower than the plan price?</strong>
                        <div class="text-muted">
                          You already have an active subscription, so you are only charged the
                          difference (proration) for the time remaining in your current billing
                          period. Starting from your next renewal, you will be billed the full
                          plan price.
                        </div>
                      </div>
                      <div *ngIf="isUpgrade && !stripePreview.currency_mismatch && stripePreview.proration_amount < 0" class="mb-2">
                        <strong>About this estimate</strong>
                        <div class="text-muted">
                          You already paid for a higher plan in your current billing period.
                          The unused amount will be applied as credit toward your next renewal,
                          so there is nothing to pay today.
                        </div>
                      </div>
                      <div><strong>Payment estimate:</strong> {{ stripePreview.estimate_label }}</div>
                      <div *ngIf="!stripePreview.currency_mismatch && stripePreview.proration_amount !== 0">
                        Proration adjustment:
                        {{ (stripePreview.proration_amount / 100) | currency:stripePreviewCurrency }}
                      </div>
                      <div *ngIf="!stripePreview.currency_mismatch && stripePreview.next_renewal_amount !== null">
                        Next renewal estimate:
                        {{ (stripePreview.next_renewal_amount! / 100) | currency:stripePreviewCurrency }}
                      </div>
                    </div>
                    <div *ngIf="stripePreviewError" class="small text-muted">{{ stripePreviewError }}</div>
                  </ng-container>
                </div>
                <div *ngIf="getAppliedPromoStripeSyncError() as promoSyncError" class="alert alert-warning">
                  {{ promoSyncError }}
                </div>
                <div *ngIf="error" class="alert alert-danger">{{ error }}</div>
                <form class="card p-2">
                <div class="input-group">
                    <input type="text" class="form-control" [(ngModel)]="promoCode" placeholder="Promo code" name="promoCode" autocomplete="off">
                    <button type="button" (click)="applyPromoCode()" class="btn btn-secondary">Redeem</button>
                </div>
                </form>
            </div>
            <div class="col-md-7 col-lg-8">
            <form [formGroup]="checkoutForm" (ngSubmit)="onSubmit()" novalidate>
                <h4 class="mb-3">Billing Name</h4>
                <div class="row">
                <div class="col-md-6 mb-3">
                    <label for="firstName">First name</label>
                    <input type="text" class="form-control" [ngClass]="{'is-invalid': isInvalid('firstName')}" id="firstName" formControlName="firstName" required autocomplete="given-name">
                    <div class="invalid-feedback">
                        Valid first name is required.
                    </div>
                </div>
                <div class="col-md-6 mb-3">
                    <label for="lastName">Last name</label>
                    <input type="text" class="form-control" [ngClass]="{'is-invalid': isInvalid('lastName')}" id="lastName" formControlName="lastName" required autocomplete="family-name">
                    <div class="invalid-feedback">
                        Valid last name is required.
                    </div>
                </div>
                </div>

                <div class="form-check mb-3">
                    <input class="form-check-input" type="checkbox" id="billingForCompany" formControlName="billingForCompany">
                    <label class="form-check-label" for="billingForCompany">Billing for a company</label>
                </div>

                <div class="alert alert-light border small" *ngIf="checkoutForm.get('billingForCompany')?.value">
                    Company billing details will be sent to Stripe so invoices show the legal company name, registered address, VAT/tax ID, and company registration number where applicable.
                </div>

                <div class="row" *ngIf="checkoutForm.get('billingForCompany')?.value">
                    <div class="col-md-6 mb-3">
                        <label for="companyName">Company Name</label>
                        <input type="text" class="form-control" [ngClass]="{'is-invalid': isInvalid('companyName')}" id="companyName" formControlName="companyName" autocomplete="organization">
                        <div class="invalid-feedback">
                            Company name is required.
                        </div>
                    </div>
                    <div class="col-md-6 mb-3">
                        <label for="taxId">VAT / Tax ID</label>
                        <input type="text" class="form-control" [ngClass]="{'is-invalid': isInvalid('taxId')}" id="taxId" formControlName="taxId" autocomplete="tax-id" placeholder="e.g. RO12345678">
                        <div class="invalid-feedback">
                            VAT or tax ID is required for company billing.
                        </div>
                    </div>
                    <div class="col-md-6 mb-3">
                        <label for="companyRegistrationNumber">Company registration number</label>
                        <input type="text" class="form-control" [ngClass]="{'is-invalid': isInvalid('companyRegistrationNumber')}" id="companyRegistrationNumber" formControlName="companyRegistrationNumber" autocomplete="off">
                        <div class="invalid-feedback">
                            Company registration number is required for company billing.
                        </div>
                    </div>
                </div>

                <div class="col-12 mb-3">
                    <label for="email">Email <span class="text-muted">(Optional)</span></label>
                    <input type="email" class="form-control" [ngClass]="{'is-invalid': isInvalid('email')}" id="email" formControlName="email" placeholder="you@example.com" autocomplete="email">
                    <div class="invalid-feedback">
                        Please enter a valid email address for shipping updates.
                    </div>
                </div>

                <hr class="my-4">

                <h4 class="mb-3">Billing address</h4>

                <div class="col-12 mb-3">
                    <label for="address">Address</label>
                    <input type="text" class="form-control" [ngClass]="{'is-invalid': isInvalid('address')}" id="address" formControlName="address" required autocomplete="street-address">
                    <div class="invalid-feedback">
                        Please enter your address for billing purposes.
                    </div>
                </div>

                <div class="col-12 mb-3">
                    <label for="address2">Address 2</label>
                    <input type="text" class="form-control" id="address2" formControlName="address2">
                </div>

                <div class="row">
                    <div class="col-md-6 mb-3">
                        <label for="country">Country</label>
                        <select class="form-select" [ngClass]="{'is-invalid': isInvalid('country')}"  id="country" formControlName="country" required (change)="onCountryChange()">
                            <option value="">Choose...</option>
                            <option *ngFor="let country of countries" [value]="country.isoCode">{{ country.name }}</option>
                        </select>
                        <div class="invalid-feedback">
                            Please select a valid country.
                        </div>
                    </div>
                    <div class="col-md-6 mb-3">
                        <label for="state">State</label>
                        <select class="form-select" [ngClass]="{'is-invalid': isInvalid('state')}" id="state" formControlName="state" required (change)="onStateChange()">
                            <option value="">Choose...</option>
                            <option *ngFor="let state of states" [value]="state.isoCode">{{ state.name }}</option>
                        </select>
                        <div class="invalid-feedback">
                            Please provide a valid state.
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 mb-3">
                        <label for="city">City</label>
                        <select class="form-select" [ngClass]="{'is-invalid': isInvalid('city')}" id="city" formControlName="city" required>
                            <option value="">Choose...</option>
                            <option *ngFor="let city of cities" [value]="city.name">{{ city.name }}</option>
                        </select>
                        <div class="invalid-feedback">
                            Please provide a valid city.
                        </div>
                    </div>
                    <div class="col-md-6 mb-3">
                        <label for="zip">Zip</label>
                        <input type="text" class="form-control" [ngClass]="{'is-invalid': isInvalid('zip')}" id="zip" formControlName="zip" required autocomplete="postal-code" maxlength="10">
                        <div class="invalid-feedback">
                            Zip code required.
                        </div>
                    </div>
                </div>

                <hr class="mb-4">

                <h4 class="mb-3">Payment</h4>

                <div class="d-block my-3">
                  <div class="checkout-payment-method d-flex align-items-center gap-3 p-3 border rounded">
                    <i class="bi bi-credit-card-2-front fs-3 text-primary"></i>
                    <div class="flex-grow-1">
                      <div class="fw-semibold">
                        Online card payment
                        <span class="badge ms-2"
                              [ngClass]="appSettingsService.stripeLivePaymentsEnabled() ? 'bg-success' : 'bg-warning text-dark'">
                          {{ appSettingsService.stripeLivePaymentsEnabled() ? 'Live' : 'Sandbox' }}
                        </span>
                      </div>
                      <div class="text-muted small">Visa, Mastercard, American Express and more.</div>
                    </div>
                  </div>
                </div>

                <div class="alert alert-info">
                  You will be redirected to our secure payment page to complete the payment.
                  The amount shown here is an estimate; the final amount and any taxes are
                  confirmed on the secure payment page before you pay.
                  <br>
                  Environment:
                  {{ appSettingsService.stripeLivePaymentsEnabled() ? 'live' : 'test' }}
                  mode.
                </div>

                <hr class="mb-4">
                <button class="btn btn-primary btn-lg btn-block d-inline-flex align-items-center justify-content-center"
                        type="submit"
                        [disabled]="processing || !!getAppliedPromoStripeSyncError()">
                  <span *ngIf="processing"
                        class="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"></span>
                  {{ processing ? 'Redirecting to secure payment…' : 'Continue' }}
                </button>
            </form>
            </div>
        </div>
        </main>
    </div>
</div>
